import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';



const useStyles = makeStyles({
  icon: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiAlert-icon': {
      display: 'none',
    },
  },
  title: {
    display: 'inline-block',
	paddingLeft:10
  }
});

const LoadingAlert = ({title, message}) => {
  const classes = useStyles();

  return (
    <Alert severity="info" className={classes.icon}>
      <div>
		<CircularProgress size={20} />
		<AlertTitle className={classes.title}>{title}</AlertTitle>
	  </div>
      {message}
    </Alert>
  );
}

export default LoadingAlert;